



































































import { Component, Vue } from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { HsabExpenseFormMode, HsabExpenseResponse, TransferSchedule, TransferScheduleStatus } from "@/shared/types";
import HsabExpenseCardRowExpenseDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseDetail.vue";
import HsabExpenseCardRowPayee from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayee.vue";
import HsabExpenseCardRowExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseEvidence.vue";
import HsabExpenseCardRowInsuranceClaim from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowInsuranceClaim.vue";
import HsabExpenseCardRowSchedule from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowSchedule.vue";
import HsabExpenseCardRowRelationships from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowRelationships.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import moment from "moment/moment";
import _ from "lodash";

@Component({
  components: {
    GenericLoadingSpinner,
    HsabExpenseCardRowInsuranceClaim,
    HsabExpenseCardRowExpenseEvidence,
    HsabExpenseCardRowPayee,
    HsabExpenseCardRowExpenseDetail,
    HsabExpenseCardRowSchedule,
    HsabExpenseCardRowRelationships,
  }
})
export default class RecurringExpenseTemplateModal extends Vue {
  themeStore = useThemeStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  hsabExpenseStore = useHsabExpenseStore();
  isDeactivating = false;

  get showModal () {
    return this.hsabExpenseFormStore.modalMode === HsabExpenseFormMode.recurringTemplate;
  }

  get expense (): HsabExpenseResponse {
    return this.hsabExpenseFormStore.expense;
  }

  get schedule (): TransferSchedule {
    if (this.expense) {
      return this.expense.schedule;
    }
    return null;
  }

  get isScheduleActive () {
    if (this.schedule) {
      return this.schedule.status === TransferScheduleStatus.Active;
    }
    return false;
  }

  get isEditable () {
    const isDuringProcessingHours = this.isProcessingTodayAndDuringProcessingHours();

    const isEditableStatus = this.checkIfThisScheduleIsInAnEditableStatus();

    return isEditableStatus && !this.isDeactivating && !isDuringProcessingHours;
  }

  get editButtonTooltip (): string {
    if (this.isEditable) {
      return "";
    }

    const isDuringProcessingHours = this.isProcessingTodayAndDuringProcessingHours();
    if (isDuringProcessingHours) {
      return "This recurring expense is currently being processed and cannot be modified. Please check back later to make edits.";
    }

    const isEditableStatus = this.checkIfThisScheduleIsInAnEditableStatus();
    if (!isEditableStatus) {
      return "This recurring expense has been completed and is no longer editable.";
    }

    return "This recurring expense cannot be edited.";
  }

  isProcessingTodayAndDuringProcessingHours () {
    let isDuringProcessingHours = false;
    if (this.hsabExpenseFormStore.generatedCalendarEntries !== undefined && this.hsabExpenseFormStore.generatedCalendarEntries !== null) {
      const nowCST = moment().tz("America/Chicago");
      const scheduledDates = _.map(this.hsabExpenseFormStore.generatedCalendarEntries.calendarDates, x => moment(x));
      const scheduleRunsToday = _.some(scheduledDates, x => x.isSame(nowCST, "day"));

      const processingStartHour = this.hsabExpenseStore.recurringScheduleProcessingStartHour;
      isDuringProcessingHours = scheduleRunsToday
          && (nowCST.hour() === processingStartHour || nowCST.hour() === (processingStartHour + 1));
    }
    return isDuringProcessingHours;
  }

  checkIfThisScheduleIsInAnEditableStatus () {
    let isEditableStatus = false;
    if (this.schedule) {
      isEditableStatus = this.schedule.status === TransferScheduleStatus.None
          || this.schedule.status === TransferScheduleStatus.Active
          || this.schedule.status === TransferScheduleStatus.Revised
          || this.schedule.status === TransferScheduleStatus.Cancelled;
    }
    return isEditableStatus;
  }

  onModalCloseClicked () {
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
  }

  onModalHidden (e) {
    // only update modal state if the user activated the close event intentionally, modal can be closed by
    // switching to edit modal, in which case we don't want to set the modalMode to None
    if (e.trigger === "esc") {
      this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
    }
  }

  onEditClicked () {
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.createOrEdit);
  }

  onDeactivateClicked () {
    this.isDeactivating = true;
    this.hsabExpenseStore.DeactivateSchedule(this.schedule.scheduleId).then(_ => {
      this.isDeactivating = false;
    }).catch(_ => {
      this.isDeactivating = false;
    });
  }
}
